import styled from "styled-components";

import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

import { LIST_HEIGHT } from "../constants";

const { carbon } = colorsPalettes;

export const Container = styled(FlexColumn)`
    width: 100%;
    height: ${LIST_HEIGHT}px;
    justify-content: center;
    align-items: center;
    gap: 32px;
`;

export const ErrorImage = styled.img`
    width: 150px;
`;

export const EmptyImage = styled.img`
    width: 200px;
`;

export const Content = styled.div`
    text-align: center;
`;

export const Title = styled.h3`
    ${setFontVariant("subtitle1", carbon[500])};
    margin: 0;
    padding: 0;
`;

export const Description = styled.p`
    ${setFontVariant("caption", carbon[300])};
    margin: 0;
    padding: 0;
`;
